import { registerContactReminderMentee } from './contact-reminder-mentee.js';
import { registerContactReminderMentor } from './contact-reminder-mentor.js';
import { registerFreeForm } from './free-form.js';
import { registerMatchingMentee } from './matching-mentee.js';
import { registerMatchingMentor } from './matching-mentor.js';
import { registerRegistrationMentee } from './registration-mentee.js';
import { registerRegistrationMentor } from './registration-mentor.js';

export const matchingMailTemplateRegisterunctions = {
  contactReminderMentee: registerContactReminderMentee,
  contactReminderMentor: registerContactReminderMentor,
  matchingMentee: registerMatchingMentee,
  matchingMentor: registerMatchingMentor,
  registrationMentee: registerRegistrationMentee,
  registrationMentor: registerRegistrationMentor,
  freeForm: registerFreeForm,
};

export type MatchingMailTemplateDefinitions = {
  [key in keyof typeof matchingMailTemplateRegisterunctions]: ReturnType<
    (typeof matchingMailTemplateRegisterunctions)[key]
  >;
};
